import { useCallback, useEffect, useState } from 'react';
import { isEmpty } from 'lodash/lang';

import { TaskApi } from '../../../../../../../api';
import { useActiveTask } from '../../../../../../../store/activeTask';
import { useCurrentRoute } from '../../../../../router';

const logRelatedTasksPages = ['Patients.Patient Info.Encounter Details.Logs', 'Patients.Patient Info.Logs'];

export default function useRelatedTasks() {
  const currentRoute = useCurrentRoute();
  const activeTask = useActiveTask();
  const [relatedTasks, setRelatedTasks] = useState(null);
  const { ssuPatientId, patientEncounterId, travelRequestId, patientItemGroupId } = currentRoute.params;

  const getPatientRelatedTasks = useCallback(
    function() {
      if (!ssuPatientId) return;
      TaskApi.getTasksByPatientIdAndSSU(ssuPatientId, activeTask.ssuId).then(({ data }) => {
        if (!isEmpty(data)) {
          setRelatedTasks(data);
        }
      });
    },
    [ssuPatientId, activeTask.ssuId]
  );

  const getRelatedTasksForEncounter = useCallback(
    function() {
      TaskApi.getTasksByPatientIdAndEncounter(ssuPatientId, patientEncounterId).then(({ data }) => {
        if (!isEmpty(data)) {
          setRelatedTasks(data);
        }
      });
    },
    [patientEncounterId, ssuPatientId]
  );

  const getRelatedTasksForCreatedTravelRequests = useCallback(
    function() {
      TaskApi.getAllPatientTasksForCreatedTravelRequest(ssuPatientId, travelRequestId).then(({ data }) => {
        if (!isEmpty(data)) {
          setRelatedTasks(data);
        }
      });
    },
    [ssuPatientId, travelRequestId]
  );

  const getAllRelatedTasksForLog = useCallback(
    function() {
      TaskApi.getTasksByPatientIdForLogs(ssuPatientId, patientItemGroupId).then(({ data }) => {
        if (!isEmpty(data)) {
          setRelatedTasks(data);
        }
      });
    },
    [patientItemGroupId, ssuPatientId]
  );

  useEffect(() => {
    if (logRelatedTasksPages.some(i => i === currentRoute.key)) {
      getAllRelatedTasksForLog();
    } else if (patientEncounterId) {
      getRelatedTasksForEncounter();
    } else if (travelRequestId) {
      getRelatedTasksForCreatedTravelRequests();
    } else {
      getPatientRelatedTasks();
    }
    return function() {
      setRelatedTasks(null);
    };
  }, [
    getAllRelatedTasksForLog,
    getPatientRelatedTasks,
    getRelatedTasksForEncounter,
    getRelatedTasksForCreatedTravelRequests,
    patientEncounterId,
    patientItemGroupId,
    currentRoute.key,
    travelRequestId
  ]);

  return relatedTasks;
}
